import { render, staticRenderFns } from "./GetProjectComponent.vue?vue&type=template&id=364c22ce&scoped=true&"
import script from "./GetProjectComponent.vue?vue&type=script&lang=js&"
export * from "./GetProjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./GetProjectComponent.vue?vue&type=style&index=0&id=364c22ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c22ce",
  null
  
)

export default component.exports